/// Keeping this for historical reference. On 2025-04-23, prcng-107_v1 was turned off
// https://app.growthbook.io/features/prcng-107_v1
// export const COLLAPSED_PAINTED_DOOR_FLAG_NAME = 'prcng-107_v1'

/// Keeping this for historical reference. On 2025-05-27, prcng-442_v1 was turned off
// https://app.growthbook.io/features/prcng-442_v1
// export const COLLAPSED_PAINTED_DOOR_FLAG_NAME = 'prcng-442_v1'

// https://app.growthbook.io/features/prcng-516_v2
export const COLLAPSED_PAINTED_DOOR_FLAG_NAME = 'prcng-516_v2'
